import { b2bDocumentsTranslations as b2bDocumentsTranslationsEn } from '@sh4res/bo-common/i18n/en/b2b/documents';

export const b2bDocumentsTranslations = {
  fields: {
    id: 'ID',
    company_id: 'ID Entreprise',
    b2b_campaign_id: 'ID Opération',
    savings_funds_request_id: 'ID Appel de fonds',
    document_url: 'URL',
    document_name: 'Nom',
    document_comment: 'Commentaire',
    type: 'Type',
    task_id: 'ID Tâche',
    co_sepa_mandate_id: 'ID Mandat SEPA',
    is_archived: 'Archivé',
    created_at: 'Créé le',
    updated_at: 'Mis à jour le',
    is_generated: 'Généré',
    source: 'Source',
  },
  choices: {
    type: {
      other: 'Autre',
      sepa_mandate_rib: 'RIB Mandat SEPA',
      b2b_business_sepa_mandate_form_signed: 'Formulaire de mandat SEPA entreprise signé',
      b2b_business_sepa_mandate_form_unsigned: 'Formulaire de mandat SEPA entreprise non signé',
      campaign_operation_summary: 'Résumé des opérations de campagne',
      csg_crds_monthly_summary: 'Attestation CSG/CRDS',
      csg_crds_annual_summary: 'Attestation CSG/CRDS annuelle',
      campaign_fund_request: 'Demande de fonds de campagne',
      matching_contribution_fund_request: "Demande de fonds d'abondement",
      in_transfer_report: 'Rapport de transfert entrant',
      out_transfer_report: 'Rapport de transfert sortant',
      transfer_in_termination_letter: 'Lettre de résiliation de transfert entrant',
      transfer_out_termination_letter: 'Lettre de résiliation de transfert sortant',
      similar_contract_certificate_document: 'Certificat de contrat similaire',
      employee_positions_list: 'Données sur les postes des employés - FRE211, FRE213, FR313',
      employee_data_fress: 'Données des employés - FRESS',
      company_rib_document: "RIB de l'entreprise",
      employees_bulk_create: 'Création en masse des affiliés',
      b2b_admin_welcome_letter: "Lettre de bienvenue de l'administrateur",
      b2b_pricing: 'Documentation tarifaire',
      b2b_admin_third_party_mandate: 'Mandat confié à un correspondant tiers',
    },
  },
  title: 'Documents',
  categories: {
    company: 'Entreprise',
    contracts: 'Contrats',
    operations: 'Documents opérations',
    certificates: 'Attestations',
    commercial_supports: 'Documents pédagogiques',
    invoices: 'Facturations',
  },
  empty: "Cette entreprise n'a aucun document",
  empty_category: 'Aucun document dans cette catégorie',
  button: 'Déposer un document',
  sections: {
    details: 'Détails du document',
  },
  create: {
    title: "Déposer un document d'entreprise",
    success: 'Document téléchargé',
    failure: 'Erreur lors du téléchargement du document : %{error}',
    label: 'Télécharger Document',
  },
} satisfies typeof b2bDocumentsTranslationsEn;
